module.exports = __webpack_public_path__ + "img/1.7de71a1d.jpg";